(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* header hairline once the page moves */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* menu drawer */
  var drawer = document.querySelector('[data-drawer]');
  var openBtn = document.querySelector('[data-menu-open]');
  var closeBtn = document.querySelector('[data-menu-close]');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.hidden = !open;
    document.body.classList.toggle('drawer-open', open);
    if (openBtn) openBtn.setAttribute('aria-expanded', String(open));
    (open ? closeBtn : openBtn) && (open ? closeBtn : openBtn).focus();
  }
  if (openBtn) openBtn.addEventListener('click', function () { setDrawer(true); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setDrawer(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && !drawer.hidden) setDrawer(false); });

  /* the living painting: fade the moving image in only once it truly plays */
  document.querySelectorAll('[data-living]').forEach(function (v) {
    if (reduce) { v.removeAttribute('autoplay'); v.pause && v.pause(); return; }
    v.addEventListener('playing', function () { v.classList.add('is-playing'); });
    var p = v.play && v.play(); if (p && p.catch) p.catch(function () {});
    document.addEventListener('visibilitychange', function () { document.hidden ? v.pause() : v.play().catch(function () {}); });
  });


  /* the opening film: the story fills the screen, then settles onto the wall as the painting */
  (function () {
    var hero = document.querySelector('[data-hero][data-intro]');
    if (!hero) return;
    var layer = hero.querySelector('[data-intro-layer]');
    var vid = hero.querySelector('[data-intro-video]');
    var win = hero.querySelector('[data-hero-window]');
    var seen = false;
    try { seen = sessionStorage.getItem('siloam-intro') === '1'; } catch (e) {}
    var inEditor = (window.Shopify && Shopify.designMode) || window.self !== window.top;
    if (reduce || seen || !layer || !vid || !win || inEditor) return;
    try { sessionStorage.setItem('siloam-intro', '1'); } catch (e) {}

    hero.classList.add('is-intro');
    layer.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var done = false, landing = false;

    function finish() {
      if (done) return; done = true;
      layer.hidden = true; layer.style.cssText = '';
      document.documentElement.style.overflow = '';
      hero.classList.remove('is-intro', 'is-landing');
      hero.classList.add('is-landed');
      window.removeEventListener('wheel', skip); window.removeEventListener('touchmove', skip); window.removeEventListener('keydown', skip);
    }
    function land() {
      if (landing || done) return; landing = true;
      window.scrollTo(0, 0);
      var r = win.getBoundingClientRect();
      hero.classList.add('is-landing');
      var from = { left: '0px', top: '0px', width: window.innerWidth + 'px', height: window.innerHeight + 'px' };
      var to = { left: r.left + 'px', top: r.top + 'px', width: r.width + 'px', height: r.height + 'px' };
      if (layer.animate) {
        var a = layer.animate([from, to], { duration: 1500, easing: 'cubic-bezier(.65,0,.25,1)', fill: 'forwards' });
        a.onfinish = function () {
          layer.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 450, fill: 'forwards' }).onfinish = finish;
        };
      } else { finish(); }
    }
    function skip() { if (!landing) land(); }
    layer.querySelector('[data-intro-skip]').addEventListener('click', function (e) { e.stopPropagation(); land(); });
    layer.addEventListener('click', skip);
    window.addEventListener('wheel', skip, { passive: true });
    window.addEventListener('touchmove', skip, { passive: true });
    window.addEventListener('keydown', skip);

    vid.addEventListener('timeupdate', function () {
      if (vid.duration && vid.currentTime > vid.duration - 1.6) land();
    });
    vid.addEventListener('ended', land);
    vid.addEventListener('error', finish);
    var p = vid.play();
    if (p && p.catch) p.catch(function () { finish(); });
    setTimeout(function () { if (vid.readyState < 2) finish(); }, 2500);   /* slow connection: don't make anyone wait */
    setTimeout(land, 9000);                                                 /* hard stop */
  })();

  /* unframed hero film: play once and hold on the last frame (the painting on the wall) */
  document.querySelectorAll('[data-hero-film] video').forEach(function (v) {
    if (reduce) { v.removeAttribute('autoplay'); return; }
    var p = v.play && v.play(); if (p && p.catch) p.catch(function () {});
  });

  /* "Sent." comes into focus as you reach it */
  var sight = document.querySelectorAll('[data-sight]');
  if (sight.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-seen'); io.unobserve(en.target); } });
    }, { threshold: 0.6 });
    sight.forEach(function (el) { io.observe(el); });
  } else { sight.forEach(function (el) { el.classList.add('is-seen'); }); }

  /* ---------------- product ---------------- */
  var product = document.querySelector('[data-product]');
  var dataEl = document.querySelector('[data-product-json]');
  if (!product || !dataEl) return;
  var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var input = product.querySelector('[data-variant-input]');
  var priceEl = product.querySelector('[data-price]');
  var addBtns = document.querySelectorAll('[data-add]');
  var barPrice = document.querySelector('[data-buybar-price]');

  function select(id) {
    var v = data.variants.filter(function (x) { return String(x.id) === String(id); })[0];
    if (!v) return;
    input.value = v.id;
    if (priceEl) priceEl.textContent = v.price;
    if (barPrice) barPrice.textContent = v.price;
    addBtns.forEach(function (b) {
      b.disabled = !v.available;
      b.textContent = v.available ? 'Add to bag' : 'Unavailable';
    });
    if (window.history && history.replaceState) {
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url.toString());
    }
  }
  product.querySelectorAll('[data-size]').forEach(function (r) {
    r.addEventListener('change', function () { select(r.value); });
  });
  select(input.value);

  /* thumbnails */
  var mainImg = product.querySelector('.product__main img');
  var mainBtn = product.querySelector('.product__main');
  product.querySelectorAll('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      product.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('is-on'); });
      t.classList.add('is-on');
      if (mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = t.dataset.src; }
      if (mainBtn) mainBtn.setAttribute('data-viewer-open', t.dataset.thumb);
    });
  });

  /* mobile buy bar appears once the main button has scrolled away */
  var bar = document.querySelector('[data-buybar]');
  var mainAdd = product.querySelector('.product__form [data-add]');
  if (bar && mainAdd && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-on', show);
      bar.setAttribute('aria-hidden', String(!show));
      bar.querySelectorAll('button').forEach(function (b) { b.tabIndex = show ? 0 : -1; });
    }).observe(mainAdd);
  }

  /* step closer: full-screen viewer with tap-to-zoom and pan */
  var viewer = document.querySelector('[data-viewer]');
  if (!viewer || !data.images.length || typeof viewer.showModal !== 'function') return;
  var stage = viewer.querySelector('[data-viewer-stage]');
  var vImg = viewer.querySelector('[data-viewer-img]');
  var count = viewer.querySelector('[data-viewer-count]');
  var idx = 0, zoomed = false, Z = 2.4;
  function show(i) {
    idx = (i + data.images.length) % data.images.length;
    unzoom(); vImg.src = data.images[idx];
    count.textContent = (idx + 1) + ' of ' + data.images.length;
  }
  function unzoom() { zoomed = false; stage.classList.remove('is-zoomed'); vImg.style.transform = ''; }
  function pan(x, y) {
    var r = vImg.getBoundingClientRect(), s = stage.getBoundingClientRect();
    var base = r.width / (zoomed ? Z : 1), baseH = r.height / (zoomed ? Z : 1);
    var px = (x - s.left) / s.width - 0.5, py = (y - s.top) / s.height - 0.5;
    var tx = -px * base * (Z - 1), ty = -py * baseH * (Z - 1);
    vImg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + Z + ')';
  }
  stage.addEventListener('click', function (e) {
    if (zoomed) { unzoom(); return; }
    zoomed = true; stage.classList.add('is-zoomed'); pan(e.clientX, e.clientY);
  });
  stage.addEventListener('pointermove', function (e) { if (zoomed) pan(e.clientX, e.clientY); });
  var sx = null, sy = null;
  stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
  stage.addEventListener('touchmove', function (e) { if (zoomed) pan(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });
  stage.addEventListener('touchend', function (e) {
    if (zoomed || sx === null) return;
    var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
    if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) show(idx + (dx < 0 ? 1 : -1));
    else if (dy > 90) viewer.close();
    sx = sy = null;
  });
  viewer.querySelector('[data-viewer-prev]').addEventListener('click', function () { show(idx - 1); });
  viewer.querySelector('[data-viewer-next]').addEventListener('click', function () { show(idx + 1); });
  viewer.querySelector('[data-viewer-close]').addEventListener('click', function () { viewer.close(); });
  viewer.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') show(idx + 1);
    if (e.key === 'ArrowLeft') show(idx - 1);
  });
  viewer.addEventListener('close', function () { unzoom(); document.body.style.overflow = ''; if (mainBtn) mainBtn.focus(); });
  if (mainBtn) mainBtn.addEventListener('click', function () {
    show(parseInt(mainBtn.getAttribute('data-viewer-open') || '0', 10));
    document.body.style.overflow = 'hidden';
    viewer.showModal();
  });
})();
